'use strict';

angular.module('atex.dam').factory('DamPublishingScheduleNode', function() {

  var DamPublishingScheduleNode = function(parentNode, id, name, day, value, isSchedule, printPublication) {
    this.id = id;

    if (name) {
      this.name = name;
    } else {
      this.name = 'no name';
    }

    this.printPublication = printPublication;
    this.day = day;
    this.collapsed = true;
    if (parentNode) {
      this.parentNode = parentNode;
      parentNode.children = parentNode.children || (parentNode.children = []);
      parentNode.children.push(this);
    }

    this.value = value;
    this.isSchedule = isSchedule ? isSchedule : false;

    if (this.isSchedule || this.value !== undefined && this.value !== null) {
      this.folderClosedIconClass = 'fa fa-folder';
      this.folderOpenIconClass = 'fa fa-folder';
    } else {
      this.folderClosedIconClass = 'fa fa-folder-o';
      this.folderOpenIconClass = 'fa fa-folder-open-o';
    }

    this.types = [];
    this.show = false;
  };

  DamPublishingScheduleNode.prototype.updateValue = function() {
      this.folderClosedIconClass = 'fa fa-folder';
      this.folderClosedIconClass = 'fa fa-folder';
  };


  DamPublishingScheduleNode.prototype.getPrintPublication = function() {
      if (this.printPublication) {
        return this.printPublication;
      }

      var depth = 0;
      var node = this;
      do  {
        node = node.parentNode;

        if (node.printPublication) {
          return node.printPublication;
        }

      } while (depth++ < 10 && node && !node.printPublication);

      console.error("Unable to find printPublication property for node: " + node + ". Tried going up: " + depth + " levels.");
  };

  DamPublishingScheduleNode.prototype.isOwner = function() {
    if (this.value && this.value.isOwner) {
      return this.value.isOwner;
    }

    var depth = 0;
    var node = this;
    do  {
      node = node.parentNode;

      if (node.value && node.value.isOwner) {
        return node.value.isOwner;
      }

    } while (depth++ < 10 && node && !node.value);

    console.error("Unable to find isOwner property for node: " + node + ". Tried going up: " + depth + " levels.");
    return false;

  };

  DamPublishingScheduleNode.prototype.resetNode = function() {
    this.folderClosedIconClass = 'fa fa-folder-o';
    this.folderOpenIconClass = 'fa fa-folder-open-o';
    this.value = null;
  };

  return DamPublishingScheduleNode;
});


angular.module('atex.dam').controller('DamPublishingSchedulesPanelController', ['$scope', '$state', '$rootScope', 'DamPublishingScheduleNode','AuthenticationService','DamSearchService', 'DamConfigurationService', 'DamNotificationService', 'DamSchedulingService', '$modal', '$q', 'DamActivityService', '$translate',
  function($scope, $state, $rootScope, DamPublishingScheduleNode, AuthenticationService, DamSearchService, DamConfigurationService, DamNotificationService, DamSchedulingService, $modal, $q, DamActivityService, $translate) {

    $scope.loading = false;
    $scope.rootNode = {};
    $scope.treemodel = [];
    $scope.selectedNode = {};
    $scope.hideRoot = true;
    $scope.data = {
      "orderingEnabled" : false,
      "allowClear" : false,
      "defaultPresetIndex" : 1
    };

    $scope.userInfo = {};
    $scope.view = { "type" : "publication" };
    $scope.view.type = "publication";
    $scope.model = {
      "dates" : [],
      "publications" : []
    };

    $translate.onReady().then(function() {
      $scope.thisWeekLabel = $translate.getTranslationTable()._THIS_WEEK_;
      $scope.nextWeekLabel = $translate.getTranslationTable()._NEXT_WEEK_;
      $scope.lastWeekLabel = $translate.getTranslationTable()._LAST_WEEK_;
      $scope.configuration = {
        presets : [
          {"label": $translate.getTranslationTable()._TODAY_, "value": "NOW/DAY TO NOW/DAY"},
          {"label": $translate.getTranslationTable()._TOMORROW_, "value": "NOW/DAY+1DAYS TO NOW/DAY+1DAYS"},
          {"label": $translate.getTranslationTable()._NEXT_7_DAYS, "value": "NOW/DAY TO NOW/DAY+7DAYS"},
        ]
      };
    });

    // Callback
    $scope.nodeSelected = function(node) {

      $scope.selectedNode = node;
      if (node && !node.isRoot) {
        $scope.listingFolder = node;
      }

      if (node && !node.isSchedule) {
        $scope.search(node.value);
      }
    };

    //Callback
    $scope.droppedOnNode = function(node, event) {
      if (node && node.value && !node.isSchedule) {
        var eventTxt = event.originalEvent.dataTransfer.getData('Text');
        var dragIds = $scope.getIdsFromDragUrl(eventTxt);
        var copy = event.ctrlKey || event.metaKey;

        DamSchedulingService.addContentToScheduleInstance(dragIds, node, copy).then(function() {
          $scope.showSpinner = false;
        }).then(null, function(error) {
          $scope.showSpinner = false;
        });
      } else {
        DamNotificationService.addNotification(atex.dam.Notification({
          type: 'error',
          message: $translate.getTranslationTable().__GENERIC_ERROR_MSG__
        }), false);
      }
    };

    //Callback
    $scope.collapseNode = function(node) {
      node.collapsed = true;
    };

    //Callback
    $scope.expandNode = function(node) {
    };

    $scope.initRootNode = function () {
      $scope.rootNode = createTreeNode(null, "root", "root", null, null, null, null);
      $scope.rootNode.isRoot = true;
      $scope.rootNode.hidden = true;
      $scope.rootNode.collapsed = false;
      $scope.treemodel.push($scope.rootNode);
    };

    function processInstance(parentNode, instance, added) {
      var locale = getLocale();
      var evalDate = moment(instance.aspects.contentData.data.publicationDate).locale(locale);

      if ($scope.view.type === 'publication') {
        checkAndProcessDate(evalDate, parentNode, instance, added);
      } else {
        var name = instance.aspects.contentData.data.publication + " - " + moment(instance.aspects.contentData.data.publicationDate, "x").format("DD-MM-YYYY");
        createTreeNode(parentNode, instance.aspects.contentData.data.id, name, null, instance, null, null);
      }
    }

    function createTreeNode(parentNode, id, name, day, value, isSchedule, printPublication) {
      return new DamPublishingScheduleNode(parentNode, id, name, day, value, isSchedule, printPublication);
    }

    $scope.populateTree = function (publicationNode, result) {
      result.forEach(function (instance) {
        processInstance(publicationNode, instance, false);
      });
    };

    function checkAndProcessDate(evalDate, publicationNode, instance, added) {
      var date  = moment().locale(getLocale());
      var sameDate = evalDate.isSame(date, 'week');
      var week = $scope.thisWeekLabel;

      [{name : $scope.nextWeekLabel, offset : 7}, {name : $scope.lastWeekLabel, offset:-7}].forEach(function (value) {
        if (!sameDate) {
          date = moment().add(value.offset, 'days').locale(getLocale());
          sameDate = evalDate.isSame(date, 'week');
          week = value.name;
        }
      });

      if (sameDate) {
        if (publicationNode.children) {
          var weekNode = publicationNode.children.filter(function (weekNode) {
            return weekNode.name === week;
          });

          if (weekNode && weekNode.length > 0) {

            var weekDayNode = weekNode[0].children.filter(function (node) {
              var m = moment(evalDate).locale(getLocale());
              return node.day.weekday() === m.weekday();
            });

            if (weekDayNode && weekDayNode.length > 0) {
                weekDayNode[0].value = instance;
                weekDayNode[0].folderClosedIconClass = 'fa fa-folder';
                weekDayNode[0].folderOpenIconClass = 'fa fa-folder';
                weekDayNode[0].printPublication = publicationNode.printPublication;
                weekDayNode[0].updateValue();
                if (added) {
                  $scope.collapseNode(weekNode[0]);
                }
            }
          }
        }
      }
    }

    function createWeeks(parentNode) {
      [{id : 0, label : $scope.thisWeekLabel}, {id : 1, label : $scope.nextWeekLabel}, {id : 2, label : $scope.lastWeekLabel}].forEach(function (item) {
            var node = createTreeNode(parentNode, DamSchedulingService.generateId, item.label, null, null, null);
            createDays(node, item.id);
      });
    }

    function getLocale() {
      var locale = $translate.resolveClientLocale();

      if (!locale) {
        locale = $translate.proposedLanguage() || $translate.use();
      }
      return locale;
    }

    //this function creates weekday nodes based on locale
    function createDays(parentNode, id) {
      [0,1,2,3,4,5,6].forEach(function (weekDay) {
        //we're just setting the locale on the local moment object - not setting it globally.
        var m = moment().locale(getLocale());
        //id determines whether it's this/next/last week
        if (id && id === 1) {
          m = m.add(7,'days');
        } else if (id && id === 2) {
          m = m.subtract(7,'days');
        }
        m = m.startOf('day');
        var day = m.weekday(weekDay);

        createTreeNode(parentNode, DamSchedulingService.generateId(), day.format('dddd'), day, null, false);
      });
    }

    $scope.resetNodeAndTree = function () {
      $scope.selectedNode = {};
      $scope.treemodel = [];
      $scope.initRootNode();
    };

    $scope.reloadSchedules = function (fromUi) {
      if ($scope.loading) {
        return;
      }
      $scope.loading = true;
      $scope.showSpinner=true;
      $scope.resetNodeAndTree();

      if ($scope.view.type === "publication") {
        $scope.reloadByPublication().then(function (result) {

        }).finally(function () {
          $scope.loading = false;
          $scope.showSpinner = false;
          if (fromUi) {
            $rootScope.$broadcast("dam:openScheduleList");
          }
        });
      } else if ($scope.view.type === "date") {
        $scope.reloadByDate();
        $scope.loading = false;
        $scope.showSpinner = false;
        if (fromUi) {
          $rootScope.$broadcast("dam:openScheduleList");
        }
      }
    };

    $scope.reloadByPublication = function () {
      return DamSchedulingService.getUniquePublicationSchedules().then(function (publications) {
        if (publications) {
          var promises = publications.map(function (publication) {
            if (publication) {
              return DamSchedulingService.getPublishingScheduleAssociatedToPublication(publication).then(function (schedule) {
                 return $scope.loadInstancesByPublication(publication).then(function (result) {
                   var publicationNode = createTreeNode($scope.rootNode, schedule ? schedule.id : DamSchedulingService.generateId(), publication, null, schedule ? schedule : null, true, publication);
                   createWeeks(publicationNode);
                   return $scope.populateTree(publicationNode, result);
                  }).then(null, function (error) {
                   $scope.showSpinner = false;
                   var message = $translate.getTranslationTable().__GENERIC_ERROR_MSG__ + " (" + error.cause + ")";
                   DamNotificationService.addNotification(atex.dam.Notification({ type: 'error', message: message }), true);
                 });
              }).then(null, function (error) {
                $scope.showSpinner = false;
                var message = $translate.getTranslationTable().__GENERIC_ERROR_MSG__ + " (" + error.cause + ")";
                DamNotificationService.addNotification(atex.dam.Notification({ type: 'error', message: message }), true);
              });
            }
          });
          return $q.all(promises);
        }
      }).then(null, function (error) {
        $scope.showSpinner = false;
        var message = $translate.getTranslationTable().__GENERIC_ERROR_MSG__ + " (" + error.cause + ")";
        DamNotificationService.addNotification(atex.dam.Notification({ type: 'error', message: message }), true);
      });
    };

    $scope.resetDateViewSelection = function() {
      $scope.model.publications = [];
      $scope.model.dates = [];
    };

    $scope.reloadByDate = function () {
      var lookups = DamConfigurationService.getSearchLookups();

      if (lookups && lookups['publications']) {
        $scope.publications = lookups['publications'];
      } else {
        $scope.publications = [];
      }
      //sets the pubDate to tomorrow and clears publications
      $scope.resetDateViewSelection();
    };

    function checkIfDateProvided () {
      var dates = $scope.model.dates;
      return dates && dates.length > 0 && dates[0];
    }

    $scope.isSearchEnabled = function () {
      return !$scope.loading && checkIfDateProvided();
    };

    $scope.searchByDateRange = function () {
      if ($scope.loading) {
        return;
      }

      if (!checkIfDateProvided()) {
        return;
      }

      $scope.loading = true;
      $scope.showSpinner=true;

      $scope.resetNodeAndTree();

      return DamSchedulingService.getInstancesByDateAndPublication($scope.model.publications, $scope.model.dates).then(function (instances) {
        return $scope.populateTree($scope.rootNode, instances);
      }).then(null, function (error) {
        $scope.showSpinner = false;
        var message = $translate.getTranslationTable().__GENERIC_ERROR_MSG__ + " (" + error.cause + ")";
        DamNotificationService.addNotification(atex.dam.Notification({ type: 'error', message: message }), true);
      }).finally(function () {
        $scope.loading = false;
        $scope.showSpinner = false;
      });
    };

    $scope.loadInstancesByPublication = function (publication) {
      var lastWeek = moment().subtract(7,'days');
      var fromDate =  lastWeek.startOf('isoWeek').toISOString();

      var nextWeek = moment().add(7, 'days');
      var toDate=  nextWeek.endOf('isoWeek').toISOString();

      return DamSchedulingService.getInstancesForPublication(publication, fromDate,toDate).then(function (instances) {
        return instances;
      }).then(null, function (error) {
        $scope.showSpinner = false;
        var message = $translate.getTranslationTable().__GENERIC_ERROR_MSG__ + " (" + error.cause + ")";
        DamNotificationService.addNotification(atex.dam.Notification({ type: 'error', message: message }), true);
      });
    };

    $scope.loadInstanceById = function (id) {
      return DamSchedulingService.loadInstancesById(id).then(function (result) {
        return result;
      }).then(null, function (error) {
        $scope.showSpinner = false;
        var message = $translate.getTranslationTable().__GENERIC_ERROR_MSG__ + " (" + error.cause + ")";
        DamNotificationService.addNotification(atex.dam.Notification({ type: 'error', message: message }), true);
      });
    };

    $scope.implementPlanManually = function (entry) {

      var modalScope = $rootScope.$new(true);
      modalScope.model = {
        "isNew" : true,
        "planningItem" : entry,
        "view" : {
          "type" : $scope.view.type
        }
      };

      var modal = $modal({
        show: true,
        scope: modalScope,
        template: 'views/dam-implement-schedule-modal.html',
        modalClass: 'dam-modal-edit confirm-modal ng-cloak',
        backdrop: 'static',
        keyboard: false
      });
      var destroyModal = function () {
        modal.then(function (modalEl) {
          modalEl.on('hidden.bs.modal', function () {
            modalScope.$destroy();
            angular.element(this).remove();
          });
          modalEl.modal('hide');
        });
      };
      modalScope.doCancel = function () {
        destroyModal();
      };
      modalScope.doOk = function (result) {

        if (result && result.data && result.data.id) {
           $scope.loadInstanceById(result.data.id).then(function (instance) {
            if (instance) {
              var parentNode = findParentNode(instance);
              if (parentNode !== null) {
                processInstance(parentNode, instance.data, true);
              }
            }
          });
        }
        destroyModal();
      };
    };

    function findParentNode(data) {
      if ($scope.view.type === 'publication') {
        var pub = data.data.aspects.contentData.data.publication;
        if ($scope.treemodel.length > 0) {
          var results = $scope.treemodel[0].children.filter(function (pubNode) {
            return pubNode.name === pub;
          });

          if (results.length > 0) {
            return results[0];
          }
        }
      }

      return null;
    }

    $scope.reloadSchedules();

    $scope.$on("dam:logout", function () {
      $scope.treemodel = [];
    });

    $scope.$on("onecms:authenticationSuccess", function () {
      $scope.reloadSchedules();
    });

    $scope.deleteScheduleInstance = function (node) {
      return DamActivityService.lock([node.value.id]).then(function () {
        return DamSchedulingService.deletePublishingScheduleInstance(node.value.id).then(function (schedule) {
          DamActivityService.unlock([node.value.id]);
          node.resetNode();
          $scope.collapseNode(node.parentNode);
          DamNotificationService.addNotification(atex.dam.Notification({
            type: 'success',
            message: $translate.getTranslationTable().__PUBLISHING_SCHEDULE_INSTANCE_DELETED__
          }), false);

          return schedule;
        }).then(null, function (error) {
          return DamActivityService.unlock([node.value.id]).then(function() {
            return $q.reject(error);
          });
        });
      }).then(null, function (error) {
        if (error && error.cause) {
          DamNotificationService.addNotification(atex.dam.Notification({
            type: 'error',
            message: $translate.getTranslationTable().__GENERIC_ERROR_MSG__ + " (" + error.cause + ")"
          }), false);
        } else {
          return $q.reject(error);
        }
      });
    };

    $scope.search = function (nodeValue) {
      if (nodeValue && nodeValue.id) {
        var isDynamic = false;

        $rootScope.$broadcast("dam:setViewMode", 'jobs');

        var ts = Date.now();
        DamSearchService.setLastQueryStartTs(ts);
        var metadataQuery = "";
        var queryId = "+schedule_instance_id_atex_desk_s:(\"" + nodeValue.id + "\")";
        metadataQuery += queryId;
        var query = {};
        query._type = "atex.dam.standard.Query";
        query.hiddenQuery = true;
        query.metadataQuery = metadataQuery;
        query.isDynamic = isDynamic;
        DamSearchService.advancedSearch(query);
      } else {
        $rootScope.$broadcast("dam:startNewQuery", true);
        $rootScope.$broadcast("dam:afterExecuteQuery");
      }
    };
}]);
